import { LoadStatus, PlayStatus } from '../../../../learnware/LearnwareEnums';
export class ChannelIntents {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get allIntents() {
        return this.parent.intents;
    }
    intentsByStatus(status) {
        return this.allIntents.filter(intent => intent.playStatus === status);
    }
    get pendingIntents() {
        return this.intentsByStatus(PlayStatus.Pending);
    }
    get startedIntents() {
        return this.intentsByStatus(PlayStatus.Go);
    }
    get loadingIntents() {
        return [...this.pendingIntents, ...this.startedIntents].filter(intent => intent.loadStatus === LoadStatus.Loading);
    }
    get playingIntents() {
        return this.intentsByStatus(PlayStatus.Playing);
    }
    get completedIntents() {
        return this.intentsByStatus(PlayStatus.Ended);
    }
    get playingAndStartedIntents() {
        return this.playingIntents.concat(this.startedIntents);
    }
}
